import { footerNav, footerDivisions, contactInfo } from '../data/siteData';
import BrandMark from './BrandMark';
import './Footer.css';

function Footer() {
  const year = new Date().getFullYear();
  const email = contactInfo.find((c) => c.label === 'Email')?.value;
  const headOffice = contactInfo.find((c) => c.label === 'Head Office')?.value;

  return (
    <footer className="site-footer">
      <div className="section-inner footer-grid">
        <div className="footer-brand-col">
          <a href="#top" className="footer-brand">
            <BrandMark className="footer-logo" fallbackClassName="footer-logo-mark" />
            <span className="footer-brand-name">Sundaravel Group</span>
          </a>
          <p className="footer-tagline">
            Lighting the path forward since 1969 — from a single match box unit in Sivakasi to a
            diversified group of eight industrial and educational divisions.
          </p>
        </div>

        <div className="footer-col">
          <h4>Explore</h4>
          <ul>
            {footerNav.map((link) => (
              <li key={link.href}>
                <a href={link.href}>{link.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-col">
          <h4>Our Divisions</h4>
          <ul>
            {footerDivisions.map((name) => (
              <li key={name}>
                <span>{name}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-col">
          <h4>Connect</h4>
          <ul>
            {email && (
              <li>
                <a href={`mailto:${email}`}>{email}</a>
              </li>
            )}
            {headOffice && <li className="footer-address">{headOffice}</li>}
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="section-inner footer-bottom-inner">
          <span>&copy; {year} Sundaravel Group. All rights reserved.</span>
          <span>Sivakasi, Tamil Nadu, India</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
